import Tooltip from '@components/tooltip'

import styles from './ai-estimated-label.module.scss'

type AIEstimatedLabelProps = {
  describedBy: string
}

export default function AIEstimatedLabel({ describedBy }: AIEstimatedLabelProps): JSX.Element {
  return (
    <Tooltip
      text="This is a salary estimation based on an analysis of comparable positions within the same geographical area."
      describedBy={describedBy}
      className={styles.tooltip}
    />
  )
}
